import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Platform } from '@ionic/angular';
import { PlatformService } from '@panamax/app-state';
import { OrderItem } from '@usf/ngrx-order';
import { ProductSummary } from '@usf/product-types/Product-Summary';
import { ImageVariantEnum } from 'src/app/product-detail/models/image-variant.enum';
import {
  getAlternativeThumbnail,
  getFirstImageURL,
} from 'src/app/product-detail/utils/product-images.util';
import { TagProduct } from '@app/shared-product/components/usf-product-tag-list/models/tag-product.model';
import { NavigationHelperService } from 'src/app/shared/helpers/navigation.helpers.service';
import { FEATURES } from '../../../../shared/constants/splitio-features';

@Component({
  selector: 'app-order-submitted-item-card',
  templateUrl: './order-submitted-item-card.component.html',
  styleUrls: ['./order-submitted-item-card.component.scss'],
})
export class OrderSubmittedItemCardComponent implements OnInit, OnChanges {
  @Input() productSummary: ProductSummary;
  @Input() lastItem: boolean;
  @Input() item: OrderItem;
  @Input() subbedItem?: OrderItem;
  @Input() subbedProductSummary?: ProductSummary;
  @Input() displayTags: TagProduct[];
  @Input() trackingNumber?: string;
  @Input() carrierCode?: string;
  @Input() restrictedNationalFlagEnabled: boolean;
  @Input() shouldHideSubbedItem?: boolean;
  @Input() availableToPromise?: boolean = false;
  @Output() openTrackingInfo: EventEmitter<any> = new EventEmitter();

  atpFeatureFlag = FEATURES.split_division_available_to_promise.name;
  maxDisplayTags = 5;
  thumbnailImageURL: string;
  splittedTrackingNumbers: string[];
  constructor(
    readonly platformService: PlatformService,
    private readonly navHelper: NavigationHelperService,
    private platform: Platform,
  ) {}
  ngOnInit(): void {
    if (this.platform?.is('mobile') && !this.platform?.is('tablet')) {
      this.maxDisplayTags = 2;
    }
    this.thumbnailImageURL = getFirstImageURL(
      this.productSummary,
      ImageVariantEnum.Thumbnail,
    );
    if (this.trackingNumber && this.trackingNumber?.includes('|')) {
      this.trackingNumber = this.trackingNumber?.split('|').slice(1).join('|');
      this.splittedTrackingNumbers = this.trackingNumber.split('|');
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.productSummary?.currentValue) {
      this.thumbnailImageURL = getFirstImageURL(
        this.productSummary,
        ImageVariantEnum.Thumbnail,
      );
    }
  }

  productClickHandler() {
    this.navHelper?.routeToProductDetails(this.productSummary?.productNumber);
  }

  callOpenTrackingInfo(trackingNumber: string) {
    this.openTrackingInfo.emit({
      trackingNumber: trackingNumber,
      carrierCode: this.carrierCode,
    });
  }

  getAternativeThumbnail = (thumbnailImageURL: string): string =>
    getAlternativeThumbnail(this.productSummary, thumbnailImageURL);
}
